import type { Language } from '../../types/document'

export interface ThemeCopy {
  appearance: string
  system: string
  light: string
  dark: string
}

export const THEME_COPY: Record<Language, ThemeCopy> = {
  en: { appearance: "Appearance", system: "Same as phone", light: "Light", dark: "Dark" },
  hi: { appearance: "रंग-रूप", system: "फ़ोन जैसा", light: "हल्का", dark: "गहरा" },
  bn: { appearance: "চেহারা", system: "ফোনের মতো", light: "হালকা", dark: "গাঢ়" },
  mr: { appearance: "रंगरूप", system: "फोनप्रमाणे", light: "फिकट", dark: "गडद" },
  ta: { appearance: "தோற்றம்", system: "போனைப் போல", light: "வெளிர்", dark: "இருள்" },
  te: { appearance: "రూపం", system: "ఫోన్ లాగే", light: "లేత", dark: "చీకటి" },
  gu: { appearance: "દેખાવ", system: "ફોન જેવું", light: "આછું", dark: "ઘેરું" },
  kn: { appearance: "ನೋಟ", system: "ಫೋನ್‌ನಂತೆ", light: "ತಿಳಿ", dark: "ಗಾಢ" },
  ml: { appearance: "രൂപം", system: "ഫോണിലേതുപോലെ", light: "ഇളം", dark: "ഇരുണ്ട" },
  pa: { appearance: "ਦਿੱਖ", system: "ਫ਼ੋਨ ਵਰਗਾ", light: "ਹਲਕਾ", dark: "ਗੂੜ੍ਹਾ" },
  or: { appearance: "ଦେଖାଣ", system: "ଫୋନ୍ ପରି", light: "ହାଲୁକା", dark: "ଗାଢ଼" },
  as: { appearance: "ৰূপ", system: "ফোনৰ দৰে", light: "পাতল", dark: "গাঢ়" },
}
